export enum WebStorage {
    SESSION_ID = "pearchSessionId",
    USER_ID = "pearchUserId",
    INSIGHTS_DISABLED = "pearchInsightsDisabled"

}